// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"3d72b542","220":"3d72b542","285":"1491787b","500":"5e65135d","540":"e8e17fbc"}[chunkId] + ".chunk.css";
};